const fullName = require('./full_name.js')

module.exports = function displayName(user) {
    if (! user) return ''
    // return full name, or user_name as a fallback
    return fullName(user) || user.user_name
}
